import Vue from 'vue';
import VueI18n from 'vue-i18n';

const translations = {
	en: {
		addParticipant: 'Add participant',
		addToCalendar: 'Add to calendar',
		address: 'Address',
		additionalInfo: 'Additional informations',
		all: 'All',
		allPricesWithOutVat: 'All prices are exl. VAT',
		approveSignup: 'Approve signup',
		associationsAndHighschools: 'Associations and highschools',
		entrepeneur: 'Entrepeneur',
		attName: 'Contactperson name',
		attEmail: 'Contactperson E-mail',
		contactPerson: 'Contactperson',
		seeTerms: 'See articles of association',
		privacyPolicy: 'How we process your personal data: Policy for personal data',
		business: 'Business',
		category: 'Category | Categories',
		choose: 'Choose',
		chooseConsultant: 'Choose Konsultant',
		chooseIndustry: 'Choose Industri',
		close: 'Close',
		chooseDownload: 'Choose download',
		chooseEducationInstitution: 'Choose education institution',
		chooseMainArea: 'Choose main area',
		chooseYourMainArea: 'Choose your main area',
		city: 'City',
		company: 'Company',
		companyInfo: 'Company details',
		continue: 'Continue',
		consultant: 'Consultant',
		copyright: 'Copyright',
		cvr: 'VAT',
		cvrNumber: 'VAT-number',
		download: 'Download',
		downloadImage: 'Download image',
		education: 'Education',
		email: 'E-mail',
		resignEmail: 'Your e-mail',
		resignPhone: 'Your phone',
		resignReason: 'Select reason',
		resignOther: 'Other',
		resignComment: 'Comment',
		resignSubmit: 'Resign membership',
		reason: 'Reason',
		emailForInvoice: 'Email for invoice',
		emailShorthand: 'E',
		emailToParticipant: 'E-mail to participant',
		employee: 'Employee | Employees',
		event: 'Event',
		fetchingCompanyInfo: 'Fetching company information',
		firm: 'Firm',
		firstName: 'First name',
		getInTouch: 'Get in touch',
		imageCredit: 'Image credit',
		industry: 'Industry',
		institution: 'Institution',
		jobs: {
			area: 'Area',
			chooseArea: 'Choose area',
			downloadResume: 'Download resume',
			showDetails: 'Show details',
			sendMail: 'Send mail',
			experience: 'Experience',
			wantedPositions: 'Wanted positions',
			currentSituation: 'Current situation',
			totalCandidates: '{count} candidates in total',
			searchPlaceholder: 'Education, name, etc. ...',
		},
		lastName: 'Last name',
		mainArea: 'Main area',
		moveToEsbjerg: 'Move to Esbjerg',
		membershipSignup: 'Membership signup',
		membershipSubscription: 'Membership subscription',
		name: 'Name',
		nameOnParticipant: 'Name on participant',
		notRequired: 'Not required',
		others: 'Others',
		participant: 'Participant',
		participants: 'Participants',
		phone: 'Phone',
		phoneShorthand: 'P',
		place: 'Place',
		playVideo: 'Play video',
		postcode: 'Postcode',
		private: 'Private',
		readMore: 'Read more',
		registration: 'Registration',
		remark: 'Remark | Remarks',
		removeParticipant: 'Remove participant',
		search: 'Search',
		searchForEvent: 'Search for event',
		searchResult:
			'The search returned <strong>no results</strong>|The search on <strong>“{str}”</strong> returned <strong>one result</strong>|The search on <strong>“{str}”</strong> returned <strong>{count} results</strong>',
		share: 'Share',
		showMore: 'Show more',
		noResultsText: 'We are sorry. There are currently no matching events',
		signup: 'Signup',
		signupAsCompany: 'Signup as company',
		signupAsPrivat: 'Signup as privat',
		signupForNewsletter: 'Subscribe to newsletter',
		subscribeNewsletter: 'Subscribe to newsletter',
		yesPlease: 'Yes please',
		newsletterCheck: 'i would like to subscribe',
		accept: 'Subscribe',
		signupOptions: 'How do you want to be signed up?',
		source: 'Source',
		studyLife: 'Students',
		entrepreneurship: 'Entrepreneurship',
		data_and_digitalization: 'Data and digitalization',
		invest_in_esbjerg: 'Invest in Esbjerg',
		entrepreneur: 'Entrepreneur',
		targetGroup: 'Target group',
		test: {
			submit: 'Test yourself',
			interests: 'We also know that your interests include ',
			and: 'and',
			back: 'Back',
			close: 'Close',
			studyLife: 'Study Life',
			situationPlaceholder: '1. Your situation',
			housingPlaceholder: '2. Living arrangements',
			interestsPlaceholder: '3. Your interests',
		},
		theCompanyAddress: "The company's address",
		theCompanyEmail: "The company's email",
		theCompanyWebsite: "The company's website",
		theCompanysName: "The company's name",
		theCompanysPhone: "The company's phone number",
		ticketType: 'Ticket type',
		topics: 'Topics',
		validateAddr: 'Address',
		validateAttName: 'Att. name',
		validateCity: 'City',
		validateCompany: 'Company',
		validateCvr: 'VR-number',
		validateEducation: 'Education',
		validateEmail: 'E-mail',
		validateFirstname: 'First name',
		validateInstitution: 'Education',
		validateLastname: 'Last name',
		validateMainArea: 'The main area',
		validateName: 'Name',
		resignName: 'Your name',
		validatePhone: 'Phone',
		validateTerms: 'The Terms',
		validateZip: 'Zip code',
		viewJobPosting: 'More',
		watchVideo: 'Watch video',
		yearsExperience: '{years} years experience',
		yourEmail: 'Your e-mail',
		yourName: 'Your name',
		contactForm: {
			yourName: 'Your name',
			email: 'E-mail',
			addCompanyName: 'Add company name',
			company: 'Company',
			addPhone: 'Add phone',
			phone: 'Phone',
			howCanWeHelp: 'How can we help you',
			message: 'Message',
			notRequired: 'not required',
			respond: 'We usually respond within 24 hours',
			time: 'on workdays. Please call us.',
			callUs: 'Call us',
			askQuestion: 'Ask',
			openToday: 'Opening hours today from',
			closedToday: 'Closed today',
			send: 'Send message',
			thanks: 'Thank you for contacting us',
			getBack: 'We will get back to you as soon as possible',
			allEmployees: 'All employees',
			error: 'An error has occurred. Please reach out for us another way.',
		},
		stickyContact: {
			canWeHelp: 'How can we help you?',
			contact: 'Get in touch with',
		},
	},
	da: {
		addParticipant: 'Tilføj deltager',
		addToCalendar: 'Tilføj til kalender',
		address: 'Adresse',
		additionalInfo: 'Yderlige informationer',
		all: 'Alle',
		allPricesWithOutVat: 'Alle beløb er ekskl. moms',
		approveSignup: 'Bekræft tilmelding',
		associationsAndHighschools: 'Brancheforeninger og gymnasier',
		attName: 'Kontaktperson',
		attEmail: 'Kontaktpersonens E-mail',
		seeTerms: 'Se vores vedtægter her',
		privacyPolicy: 'Sådan behandler vi dine personoplysninger: Politik for personoplysninger',
		business: 'Erhverv',
		category: 'Kategori | Kategorier',
		choose: 'Vælg',
		chooseConsultant: 'Vælg Konsulent',
		chooseIndustry: 'Vælg branche',
		close: 'Luk',
		chooseDownload: 'Vælg download',
		chooseEducationInstitution: 'Vælg uddannelsessted',
		chooseMainArea: 'Vælg interesseområder',
		chooseYourMainArea: 'Vælg dine interesseområder',
		city: 'By',
		company: 'Virksomhed',
		companyInfo: 'Virksomhedsoplysninger',
		contactPerson: 'Kontaktperson',
		continue: 'Fortsæt',
		consultant: 'Konsulent',
		copyright: 'Ophavsret',
		cvr: 'CVR',
		cvrNumber: 'CVR-nummer',
		download: 'Download',
		downloadImage: 'Download billede',
		education: 'Uddannelse',
		email: 'E-mail',
		resignEmail: 'E-mail på udmelder',
		resignPhone: 'Telefonnummer på udmelder',
		resignReason: 'Vælg årsag',
		reason: 'Årsag',
		resignOther: 'Andet',
		resignComment: 'Kommentar',
		resignSubmit: 'Opsig medlemskab',
		emailForInvoice: 'Mailadresse til fakturering',
		emailShorthand: 'E',
		emailToParticipant: 'E-mail til deltager',
		employee: 'Ansat | Ansatte',
		event: 'Arrangement',
		fetchingCompanyInfo: 'Henter virksomhedsoplysninger',
		firm: 'Firma',
		firstName: 'Fornavn',
		getInTouch: 'Kontakt',
		imageCredit: 'Kreditering',
		industry: 'Branche',
		institution: 'Institution',
		jobs: {
			area: 'Område',
			chooseArea: 'Vælg område',
			downloadResume: 'Download CV',
			showDetails: 'Vis detaljer',
			sendMail: 'Send mail',
			experience: 'Erfaring',
			wantedPositions: 'Ønskede stillinger',
			currentSituation: 'Nuværende situation',
			totalCandidates: '{count} kandidater i alt',
			searchPlaceholder: 'Uddannelse, navn, mm. ...',
		},
		lastName: 'Efternavn',
		mainArea: 'Interesseområder',
		moveToEsbjerg: 'Flyt til Esbjerg',
		membershipSignup: 'Bliv medlem',
		membershipSubscription: 'Medlemskontingent',
		entrepeneur: 'Iværksætter',
		name: 'Navn',
		nameOnParticipant: 'Navn på deltager',
		notRequired: 'Ikke påkrævet',
		others: 'Andre',
		participant: 'Deltager',
		participants: 'Deltagere',
		phone: 'Telefon',
		phoneShorthand: 'T',
		place: 'Sted',
		playVideo: 'Afspil video',
		postcode: 'Postnummer',
		private: 'Privat',
		readMore: 'Få mere viden',
		registration: 'Registrering',
		remark: 'Bemærkning | Bemærkninger',
		removeParticipant: 'Fjern deltager',
		search: 'Søg',
		searchForEvent: 'Søg efter arrangement',
		searchResult:
			'Din søgning gav <strong>intet resultat</strong>|Din søgning på <strong>“{str}”</strong> gav <strong>et resultat</strong>|Din søgning på <strong>“{str}” gav <strong>{count} resultater</strong>',
		share: 'Del',
		showMore: 'Vis flere',
		noResultsText: 'Vi beklager. Der er pt. ingen matchende arrangementer',
		signup: 'Tilmeld',
		signupAsCompany: 'Tilmeld som virksomhed',
		signupAsPrivat: 'Tilmeld som privat',
		signupForNewsletter: 'Tilmeld nyhedsbrev',
		yesPlease: 'Ja tak',
		newsletterCheck: 'jeg vil gerne modtage nyhedsbrevet',
		accept: 'Giv samtykke',
		signupOptions: 'Hvordan vil du tilmeldes?',
		source: 'Kilde',
		startupDateOrMessage: 'Bemærkninger (foreksempel etableringsdato)',
		studyLife: 'Studerende',
		entrepreneurship: 'Iværksætteri',
		data_and_digitalization: 'Data og digitalisering',
		invest_in_esbjerg: 'Invest In Esbjerg',
		entrepreneur: 'Iværksætter',
		targetGroup: 'Målgruppe',
		test: {
			submit: 'Tag testen',
			interests: 'Vi ved også at du interesserer dig for ',
			and: 'og',
			back: 'Tilbage',
			close: 'Luk testen',
			studyLife: 'Aktiv studieby',
			situationPlaceholder: '1. Hvad er din situation?',
			housingPlaceholder: '2. Hvordan vil du bo?',
			interestsPlaceholder: '3. Hvad er dine interesser?',
		},
		theCompanyAddress: 'Virksomhedens adresse',
		theCompanyEmail: 'Virksomhedens email',
		theCompanyWebsite: 'Virksomhedens website',
		theCompanysName: 'Virksomhedens navn',
		theCompanysPhone: 'Virksomhedens telefonnummer',
		subscribeNewsletter: 'Jeg vil gerne modtage Business Esbjergs nyhedsbrev',
		ticketType: 'Tilmeldes som',
		topics: 'Emner',
		validateAddr: 'Feltet',
		validateAttName: 'Feltet',
		validateCity: 'Feltet',
		validateCompany: 'Feltet',
		validateCvr: 'Feltet',
		validateEducation: 'Feltet',
		validateEmail: 'E-mailen',
		validateFirstname: 'Fornavnet',
		validateInstitution: 'Feltet',
		validateLastname: 'Efternavnet',
		validateMainArea: 'Interesseområdet',
		validateName: 'Feltet',
		validatePhone: 'Feltet',
		resignName: 'Navn på udmelder',
		validateTerms: 'Betingelserne',
		validateZip: 'Feltet',
		viewJobPosting: 'Se opslag',
		watchVideo: 'Se video',
		yearsExperience: '{years} års erfaring',
		yourEmail: 'Din e-mail',
		yourName: 'Dit navn',
		contactForm: {
			yourName: 'Dit navn',
			email: 'E-mail',
			addCompanyName: 'Tilføj virksomhedsnavn',
			company: 'Virksomhed',
			addPhone: 'Tilføj telefonnummer',
			phone: 'Telefon',
			howCanWeHelp: 'Hvad kan vi hjælpe dig med',
			message: 'Besked',
			notRequired: 'ikke påkrævet',
			respond: 'Vi svarer normalt indenfor 24 timer',
			time: 'på hverdage. Ring gerne til os.',
			callUs: 'Ring til os',
			askQuestion: 'Stil et spørgsmål til',
			openToday: 'Åbent i dag fra kl.',
			closedToday: 'Lukket i dag',
			send: 'Send besked',
			thanks: 'Tak for din besked',
			getBack: 'Vi vender tilbage til dig hurtigst muligt',
			allEmployees: 'Se alle medarbejdere',
			error:
				'Der er desværre sket en fejl. Prøv igen eller kontakt os på anden vis.',
		},
		stickyContact: {
			canWeHelp: 'Kan vi hjælpe dig?',
			contact: 'Skriv eller ring til',
		},
	},
	validations: {
		en: {},
		da: {},
	},
};

// Create VueI18n instance with options
Vue.use(VueI18n);

export const i18n = new VueI18n({
	locale: 'da', // set locale
	messages: translations, // set locale messages
});
